module.exports = __webpack_public_path__ + "media/images/icons/filled/dollar-circle-07a438e7bcc7aa765651627993a7fc01.svg";